export enum PaymentTypeEnum {
    CreditCard = 0,
    PayPal = 1,
    BankTransfer = 2,
    Free = 3
}